
import { defineComponent, reactive, toRefs, computed, onMounted, h } from 'vue'
import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10ApiUS from '@/api/f10ApiUS'
import { isLocalDev } from '@/api/config'

export default defineComponent({
  components: { Table, Nodata },
  props: {
    token: { type: String, default: '' },
    itemdata: { type: Object, default: () => ({}) },
    pageSourceData: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const pageData = reactive({
      allData: [] as any[],  // 存储所有数据
      columns: [
        {
          title: '变动日期',
          dataIndex: 'chgDate',
          key: 'chgDate',
          width: '120px',
          customRender: ({ record }: any) => {
            if (record.chgDate) {

              return window.moment(record.chgDate).format('YYYY-MM-DD')
            }
            return '—'
          }
        },
        {
          title: '机构持仓比例',
          dataIndex: 'orgPositionCalc',
          key: 'orgPositionCalc',
          width: '120px',
          slots: { customRender: 'nocolorincrease' },
          align: 'right'
        },
        {
          title: '环比净交易 (万股)',
          dataIndex: 'netTradeVol',
          key: 'netTradeVol',
          width: '150px',
          align: 'right',
          customRender: ({ record }: any) => {
            if (record.netTradeVol !== undefined && record.netTradeVol !== null) {
              // 将数值转换为万为单位显示
              const value = record.netTradeVol / 10000
              return value.toFixed(2)
            }
            return '—'
          }
        },
        {
          title: '机构数量 (家)',
          dataIndex: 'holderNum',
          key: 'holderNum',
          width: '120px',
          slots: { customRender: 'peopleCount' },
          align: 'right'
        }
      ],
      total: 0,
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前页码
      spinning: true,
    })

    // 本地分页计算当前页数据
    const pagedData = computed(() => {
      const start = (pageData.currentPage - 1) * pageData.pageSize
      const end = start + pageData.pageSize
      return pageData.allData.slice(start, end)
    })

    // 分页配置
    // 分页配置
    const pagination = reactive({
      total: 0,
      get current() {
        return pageData.currentPage
      },
      set current(val: number) {
        pageData.currentPage = val
      },
      pageSize: pageData.pageSize,
      showSizeChanger: true,
      showTotal: (total: number) => `共${total}条`,
      pageSizeOptions: ['10', '20', '50', '100'],
      onChange: (page: number, pageSize?: number) => {
        pageData.currentPage = page
        if (pageSize) pageData.pageSize = pageSize
      },
      onShowSizeChange: (current: number, size: number) => {
        pageData.currentPage = 1
        pageData.pageSize = size
      }
    })


    // 转换接口数据，补充 key
    function transformData(raw: any[]) {
      return raw.map((item, index) => ({
        ...item,
        key: item.id || index,
      }))
    }

    // 获取数据
    function fetchData() {
      pageData.spinning = true

      const route = useRoute()

      // 本地开发环境使用默认参数，否则使用路由参数
      let market: string, symbol: string
      if (isLocalDev) {
        market = 'NASDAQ'
        symbol = 'AAPL'
      } else {
        market = route.query.market as string || 'NASDAQ'
        symbol = route.query.code as string || 'AAPL'
      }

      const data: any = {
        data: {
          symbol,  // 股票代码
          market,  // 市场代码
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944',
        },
      }

      f10ApiUS.getJgcc(data).then((res: any) => {
        if (res && res.data) {
          // 根据getJgcc接口的实际返回结构调整
          let listData = []
          if (Array.isArray(res.data.list)) {
            listData = res.data.list
          }

          pageData.allData = transformData(listData)
          pageData.total = pageData.allData.length
          pagination.total = pageData.total // 更新分页总条数
          pagination.current = pageData.currentPage
          pagination.pageSize = pageData.pageSize
        } else {
          pageData.allData = []
          pageData.total = 0
          pagination.total = 0
        }
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })
    }

    onMounted(() => {
      fetchData()
    })

    return {
      ...toRefs(pageData),
      pagedData,
      pagination
    }
  },
})
